import { render, staticRenderFns } from "./calendarPage.vue?vue&type=template&id=bce263e4&"
import script from "./calendarPage.vue?vue&type=script&lang=js&"
export * from "./calendarPage.vue?vue&type=script&lang=js&"
import style0 from "./calendarPage.vue?vue&type=style&index=0&id=bce263e4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports